// src/manuals_render_new.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useGlobalSearch } from '../../hooks/useGlobalSearch';
import { products } from '../../data'
import { allArticulos } from '../../data';
import { Link, useLocation } from "react-router-dom";
import { DocumentTextIcon } from "@heroicons/react/outline";


// Mapping de imágenes por categoría de producto
const categoryImages = {
    panel_admin: 'https://img.invupos.com/webinvu/ManualsRenderNew/Administrador_monnim.png',
    guias_clau: 'https://img.invupos.com/webinvu/ManualsRenderNew/clau-guias_lekhw5.png',
    facturacion_electronica: 'https://img.invupos.com/webinvu/ManualsRenderNew/facturacion_electronica_za4szu.png',
    invu_pos: 'https://img.invupos.com/webinvu/ManualsRenderNew/icon3_ysccbd.png',
    release_notes: 'https://img.invupos.com/webinvu/ManualsRenderNew/releasenotes_qy4cov.png',
    integraciones_manuales: 'https://img.invupos.com/webinvu/ManualsRenderNew/Integrations_rpxagk.png',
  }

  export default function ManualsRenderNew() {
    const { query, setQuery, resultados } = useGlobalSearch();
    const [selProd, setSelProd] = useState(products[0]?.id);
    const [selCat, setSelCat] = useState(products[0]?.subcategorias[0]?.id);
    const [openProds, setOpenProds] = useState([]);
  
    // Al montar, leemos el producto seleccionado y preabrimos su sección
    useEffect(() => {
      const savedProd = localStorage.getItem('selectedManualProduct');
      const initialProd = savedProd && products.some(p => p.id === savedProd)
        ? savedProd
        : products[0]?.id;
  
      // configuramos estados
      setSelProd(initialProd);
      const defaultCat = products.find(p => p.id === initialProd).subcategorias[0]?.id;
      setSelCat(defaultCat);
      setOpenProds([initialProd]);
  
      // limpiamos
      localStorage.removeItem('selectedManualProduct');
    }, []);
  
    const prod = products.find(p => p.id === selProd);
    const cats = prod?.subcategorias || [];
    const selectedCat = cats.find(c => c.id === selCat);
  
    const ultimas = allArticulos
      .filter(a => a.fecha)
      .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
      .slice(0, 4);
  
    const timeSince = (dateString) => {
      const diffMs = Date.now() - new Date(dateString).getTime();
      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      if (days < 30) return `${days} days ago`;
      const months = Math.floor(days / 30);
      return `${months} months ago`;
    };
  
    return (
      <>
        <div className="mt-12">
          <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 max-w-screen-md mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              ¿Cómo podemos ayudarle?
            </h3>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex flex-col md:flex-row items-stretch gap-4 relative"
            >
              <input
                type="text"
                placeholder="Cuéntanos tu problema..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {query && resultados.length > 0 && (
                <ul className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-b-2xl shadow-lg max-h-60 overflow-auto mt-1 z-20">
                  {resultados.map((item) => (
                    <li
                      key={`${item.producto}-${item.id}`}
                      className="px-4 py-2 hover:bg-gray-100 flex items-center gap-2"
                    >
                      <DocumentTextIcon className="h-5 w-5 text-blue-500" />
                      <Link
                        onClick={() => window.scrollTo(0, 0)}
                        to={item.enlace}
                        className="flex-1 text-gray-800"
                      >
                        {item.titulo}
                      </Link>
                      <span className="text-xs text-gray-400">{item.producto}</span>
                    </li>
                  ))}
                </ul>
              )}
              <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition h-full flex items-center justify-center"
              >
                🔍 Buscar
              </button>
            </form>
          </div>
        </div>
  
        <div className="flex flex-col lg:flex-row max-w-7xl px-6 py-16 md:px-12 lg:py-24 space-y-6 lg:space-y-0 lg:space-x-6 mx-auto">
          {/* ← PANEL IZQUIERDO: ACORDEÓN MULTI-APERTURA */}
          <nav className="w-full lg:w-1/3 bg-white shadow-sm rounded overflow-auto divide-y divide-gray-300">
          {products.map(p => {
            const isOpen = openProds.includes(p.id);
            return (
              <div key={p.id}>
                <button
                  className={`flex items-center justify-between w-full px-4 py-3 text-left
                    ${isOpen
                      ? 'font-semibold text-gray-900 border-l-4 border-blue-500 bg-blue-50'
                      : 'text-gray-700 hover:bg-gray-50'}`}
                  onClick={() => {
                    if (isOpen) {
                      // cierro
                      const updated = openProds.filter(id => id !== p.id);
                      setOpenProds(updated);
                      // ajusto panel derecho si cerré el seleccionado
                      if (selProd === p.id) {
                        const next = updated[0] || products[0].id;
                        setSelProd(next);
                        setSelCat(products.find(x => x.id === next).subcategorias[0]?.id);
                      }
                    } else {
                      // abro
                      setOpenProds(prev => [...prev, p.id]);
                      setSelProd(p.id);
                      setSelCat(p.subcategorias[0]?.id);
                    }
                  }}
                >
                  <span>{p.nombre}</span>
                  <svg
                    className={`w-4 h-4 text-gray-600 transition-transform ${isOpen ? 'rotate-90' : ''}`}
                    viewBox="0 0 16 16" fill="none"
                  >
                    <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

                {isOpen && (
                  // ahora usamos dividers más gruesos y color claro
                  <div className='divide-y divide-gray-200'>
                    {p.subcategorias.map(c => {
                      const isCatOpen = selCat === c.id;
                      return (
                        <div key={c.id}>
                          <button
                            className={`flex items-center justify-between w-full pl-8 pr-4 py-2 text-sm
                              ${isCatOpen ? 'text-gray-900 bg-gray-100' : 'text-gray-600 hover:bg-gray-50'}`}
                            onClick={() => setSelCat(c.id)}
                          >
                            <span className='text-left'>– {c.nombre}</span>
                            <svg
                              className={`w-3 h-3 text-gray-500 transition-transform ${isCatOpen ? 'rotate-90' : ''}`}
                              viewBox="0 0 16 16" fill="none"
                            >
                              <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                          {isCatOpen && (
                            <div className="pl-12 bg-white">
                              {c.articulos.map(a => (
                                <a key={a.id} href={a.enlace} className="block text-sm text-gray-600 py-1 hover:text-gray-800">
                                  · {a.titulo}
                                </a>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
  
        {/* → PANEL DERECHO: GRID DE TARJETAS CON IMAGEN POR CATEGORÍA Y METADATA */}
        <section className="w-full lg:flex-1">
           {selectedCat && (
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              {prod.nombre}{' '}
              <span className="italic font-normal text-gray-600">{selectedCat.nombre}</span>
            </h2>
          )}

          {selectedCat?.articulos?.length ? (
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              {selectedCat.articulos.map(a => (
                <a
                  key={a.id}
                  href={a.enlace}
                  className="block bg-white border border-gray-300 rounded-xl p-6 transition-colors hover:border-indigo-600"
                >
                  {/* Imagen según categoría de producto */}
                  {categoryImages[prod.id] && (
                    <img
                      src={categoryImages[prod.id]}
                      alt={prod.nombre}
                      className="w-12 mb-4"
                    />
                  )}
  
                  {/* Título */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {a.titulo}
                  </h3>
  
                  {/* Metadata: Steps, fecha, producto y subcategoría */}
                  <div className="mt-2 text-sm text-gray-500 space-y-1">
                    <div>{a.steps ?? '—'} Steps</div>
                    {a.fecha && <div>{timeSince(a.fecha)}</div>}
                    <div>{prod.nombre}</div>
                  </div>
                </a>
              ))}
            </div>
          ) : (
            <p className="text-gray-500">No hay artículos en esta sección.</p>
          )}
        </section>
      </div>
      </>
    )
  }
  